import React, { useEffect, useState } from "react";
import Header from "../../vapor/header";
import ImgBis from "../../../assets/img/Human.svg";
import Item from "../../vapor/item";
import { TextField } from "@vapor/react-material";
import Checkbox from "../../vapor/checkbox";
import Button from "../../vapor/button";
import Uploader from "../../general/uploader";
import {
    faAddressCard,
    faCreditCard,
} from "@fortawesome/pro-regular-svg-icons";
import { OnboardingSave } from "../../../interfaces/onboarding";
import { FormattedMessage, useIntl } from "react-intl";
import { fiscalCodeValidity } from "../../../services/text-operations";
import { DatePicker } from "@vapor/react-x-date-pickers";
import moment from "moment";
import { RootState } from "../../../reducers/store";
import { useSelector } from "react-redux";

interface OnboardingComponentProps {
    setStep: (val: number) => void;
    onSave: (bodyRequest: OnboardingSave) => void;
}

const defaultBodyRequest: any = {
    check: false,
    frontDoc: "",
    backDoc: "",
    firstName: "",
    lastName: "",
    fiscalCode: "",
    expiringDate: "",
    acceptGenericTerms: false,
    acceptSpecificClauses: false,
    acceptMarketing: false,
    acceptShareData: false,
};

const OnboardingStep2 = (props: OnboardingComponentProps) => {
    const onboarding = useSelector((state: RootState) => state.onboarding);
    const [bodyRequest, setBodyRequest] = useState(
        !onboarding?.consent?.acceptGenericTerms
            ? defaultBodyRequest
            : {
                  ...defaultBodyRequest,
                  firstName: onboarding?.subject?.name,
                  lastName: onboarding?.subject?.surname,
                  fiscalCode: onboarding?.subject?.fiscal_code,
                  acceptGenericTerms: onboarding?.consent?.acceptGenericTerms,
                  acceptSpecificClauses:
                      onboarding?.consent?.acceptSpecificClauses,
              },
    );
    const readOnlyFields = !onboarding?.consent?.acceptGenericTerms
        ? {}
        : {
              firstName: true,
              lastName: true,
              fiscalCode: true,
              acceptGenericTerms: true,
              acceptSpecificClauses: true,
          };
    const [enableSave, setEnableSave] = useState(false);
    const [wrongFiscalCode, setWrongFiscalCode] = useState(false);

    const intl = useIntl();

    useEffect(() => {
        setEnableSave(
            bodyRequest.frontDoc &&
                bodyRequest.backDoc &&
                bodyRequest.check &&
                bodyRequest.firstName &&
                bodyRequest.lastName &&
                bodyRequest.fiscalCode &&
                bodyRequest.expiringDate &&
                bodyRequest.acceptGenericTerms &&
                bodyRequest.acceptSpecificClauses &&
                fiscalCodeValidity(bodyRequest.fiscalCode)
                ? true
                : false,
        );
    }, [bodyRequest]);

    return (
        <div className="bis-onboarding-settings">
            <Header
                title="BUSINESS INFORMATION"
                showBack={true}
                onBack={() => props.setStep(1)}
            />
            <div className="bis-onboarding-settings-content">
                <div className="bis-onboarding-settings-content-left">
                    <div className="bis-onboarding-settings-content-left-image">
                        <img src={ImgBis} alt=""></img>
                    </div>
                    <div className="bis-onboarding-settings-content-left-list">
                        <div className="bis-onboarding-settings-content-left-list-title">
                            <FormattedMessage id="onboarding.listTitle" />
                        </div>
                        <ul>
                            <li>
                                <FormattedMessage id="onboarding.list1" />
                            </li>
                            <li>
                                <FormattedMessage id="onboarding.list2" />
                            </li>
                            <li>
                                <FormattedMessage id="onboarding.list3" />
                            </li>
                        </ul>
                    </div>
                    <div className="bis-onboarding-settings-content-left-list">
                        <div className="bis-onboarding-settings-content-left-list-title">
                            <FormattedMessage id="onboarding.listTitlePrivacy" />
                        </div>
                        <ul>
                            <li>
                                <FormattedMessage id="onboarding.listPrivacy1" />
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="bis-onboarding-settings-content-right">
                    <div className="bis-onboarding-settings-content-form">
                        <div className="bis-onboarding-settings-content-form-section">
                            <div className="bis-onboarding-settings-content-form-section-title">
                                <FormattedMessage id="onboarding.data" />
                            </div>
                            <div className="bis-onboarding-settings-content-form-section-subtitle">
                                <FormattedMessage id="onboarding.dataSub" />
                            </div>
                            <div
                                className="bis-onboarding-settings-content-form-section-title"
                                style={{ marginTop: 16 }}
                            >
                                <FormattedMessage id="onboarding.registryData" />
                            </div>
                            <div className="bis-onboarding-settings-content-form-section-fields">
                                <Item label="Nome *">
                                    <TextField
                                        onChange={(e: any) =>
                                            setBodyRequest({
                                                ...bodyRequest,
                                                firstName: e.target.value,
                                            })
                                        }
                                        value={bodyRequest.firstName}
                                        autoFocus
                                        name="bis-onboarding-firstName"
                                        disabled={readOnlyFields.firstName}
                                        placeholder="Inserisci il nome"
                                        inputProps={{
                                            maxLength: 30,
                                        }}
                                    />
                                </Item>
                                <Item label="Cognome *">
                                    <TextField
                                        onChange={(e: any) =>
                                            setBodyRequest({
                                                ...bodyRequest,
                                                lastName: e.target.value,
                                            })
                                        }
                                        value={bodyRequest.lastName}
                                        disabled={readOnlyFields.lastName}
                                        name="bis-onboarding-lastName"
                                        placeholder="Inserisci il cognome"
                                        inputProps={{
                                            maxLength: 30,
                                        }}
                                    />
                                </Item>
                                <Item label="Codice Fiscale *">
                                    <TextField
                                        disabled={readOnlyFields.fiscalCode}
                                        onChange={(e: any) => {
                                            setBodyRequest({
                                                ...bodyRequest,
                                                fiscalCode:
                                                    e.target.value.toUpperCase(),
                                            });
                                            setWrongFiscalCode(false);
                                        }}
                                        onBlur={() => {
                                            if (
                                                bodyRequest.fiscalCode.length >
                                                    0 &&
                                                !fiscalCodeValidity(
                                                    bodyRequest.fiscalCode,
                                                )
                                            ) {
                                                setWrongFiscalCode(true);
                                            }
                                        }}
                                        value={bodyRequest.fiscalCode}
                                        name="bis-onboarding-fiscalCode"
                                        placeholder="Inserisci il codice fiscale"
                                        error={wrongFiscalCode}
                                        inputProps={{
                                            maxLength: 16,
                                        }}
                                        helperText={
                                            wrongFiscalCode &&
                                            "Codice fiscale non valido"
                                        }
                                    />
                                </Item>
                            </div>
                        </div>
                        <div className="bis-onboarding-settings-content-form-section">
                            <div className="bis-onboarding-settings-content-form-section-title">
                                <FormattedMessage id="onboarding.identityCard" />
                            </div>
                            <div className="bis-onboarding-settings-content-form-section-fields">
                                <Item width={300} label="Fronte *">
                                    <Uploader
                                        file={bodyRequest.frontDoc}
                                        accept={{
                                            "image/jpeg": [".jpeg", ".png"],
                                        }}
                                        name="front-document-upload"
                                        onFileSelect={(data) => {
                                            setBodyRequest({
                                                ...bodyRequest,
                                                frontDoc: data,
                                            });
                                        }}
                                        icon={faAddressCard}
                                    />
                                </Item>
                                <Item width={300} label="Retro *">
                                    <Uploader
                                        file={bodyRequest.backDoc}
                                        accept={{
                                            "image/jpeg": [".jpeg", ".png"],
                                        }}
                                        name="back-document-upload"
                                        onFileSelect={(data) => {
                                            setBodyRequest({
                                                ...bodyRequest,
                                                backDoc: data,
                                            });
                                        }}
                                        icon={faCreditCard}
                                    />
                                </Item>
                            </div>
                        </div>
                        <div className="bis-onboarding-settings-content-form-section">
                            <div className="bis-onboarding-settings-content-form-section-fields">
                                <DatePicker
                                    label={intl.formatMessage({
                                        id: "onboarding.deadline",
                                    })}
                                    value={bodyRequest.expiringDate}
                                    onChange={(val: any) =>
                                        setBodyRequest({
                                            ...bodyRequest,
                                            expiringDate: val,
                                        })
                                    }
                                    renderInput={(params: any) => (
                                        <TextField
                                            {...params}
                                            helperText={null}
                                            error={false}
                                            style={{ width: 320 }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="bis-onboarding-settings-content-form-section-fields">
                                <Checkbox
                                    disabled={
                                        bodyRequest.firstName === "" ||
                                        bodyRequest.lastName === "" ||
                                        bodyRequest.fiscalCode === "" ||
                                        bodyRequest.frontDoc === "" ||
                                        bodyRequest.backDoc === "" ||
                                        !(
                                            bodyRequest.expiringDate instanceof
                                                Date &&
                                            !isNaN(bodyRequest.expiringDate)
                                        )
                                    }
                                    name={"bis-onboarding-check"}
                                    value={"bis-onboarding-check"}
                                    label={
                                        "Confermo che i dati e i documenti inseriti sono relativi al legale rappresentante e in corso di validità"
                                    }
                                    onChange={(val) =>
                                        setBodyRequest({
                                            ...bodyRequest,
                                            check: val,
                                        })
                                    }
                                    checked={bodyRequest.check}
                                />
                            </div>
                        </div>
                        <div
                            className="bis-onboarding-settings-content-form-section"
                            style={{ marginTop: 16 }}
                        >
                            <div className="bis-onboarding-settings-content-form-section-title">
                                <FormattedMessage id="onboarding.privacy" />
                            </div>
                            <div
                                className="bis-onboarding-settings-content-form-section-subtitle"
                                style={{ marginBottom: 8 }}
                            >
                                <FormattedMessage
                                    id="onboarding.privacySub"
                                    values={{
                                        a: (chunks: any) => (
                                            <a
                                                href="https://privacy.modefinance.com/it"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {chunks}
                                            </a>
                                        ),
                                    }}
                                />
                            </div>
                            <div
                                className={
                                    "bis-onboarding-settings-content-form-section-privacy-line" +
                                    (readOnlyFields.acceptGenericTerms
                                        ? " disabled"
                                        : "")
                                }
                            >
                                <Checkbox
                                    disabled={readOnlyFields.acceptGenericTerms}
                                    name={"bis-onboarding-privacy1"}
                                    value={"bis-onboarding-privacy1"}
                                    label={""}
                                    onChange={(val) =>
                                        setBodyRequest({
                                            ...bodyRequest,
                                            acceptGenericTerms: val,
                                        })
                                    }
                                    checked={bodyRequest.acceptGenericTerms}
                                />
                                <FormattedMessage
                                    id="onboarding.privacy1"
                                    values={{
                                        a: (chunks: any) => (
                                            <a
                                                href="https://tc.teamsystem.com/CGServiziDigitalModefinance.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{ marginLeft: 4 }}
                                            >
                                                {chunks}
                                            </a>
                                        ),
                                    }}
                                />
                            </div>
                            <div
                                className={
                                    "bis-onboarding-settings-content-form-section-privacy-line" +
                                    (readOnlyFields.acceptGenericTerms
                                        ? " disabled"
                                        : "")
                                }
                                style={{ marginBottom: 16 }}
                            >
                                <Checkbox
                                    name={"bis-onboarding-privacy2"}
                                    value={"bis-onboarding-privacy2"}
                                    disabled={
                                        readOnlyFields.acceptSpecificClauses
                                    }
                                    label={""}
                                    onChange={(val) =>
                                        setBodyRequest({
                                            ...bodyRequest,
                                            acceptSpecificClauses: val,
                                        })
                                    }
                                    checked={bodyRequest.acceptSpecificClauses}
                                />
                                <FormattedMessage id="onboarding.privacy2" />
                            </div>
                            <div
                                className="bis-onboarding-settings-content-form-section-subtitle"
                                style={{ marginTop: 8, marginBottom: 4 }}
                            >
                                <FormattedMessage
                                    id="onboarding.privacySub2"
                                    values={{
                                        a: (chunks: any) => (
                                            <a
                                                href="https://www.modefinance.com/it/privacy-policy"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {chunks}
                                            </a>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="bis-onboarding-settings-content-form-section-privacy-line">
                                <Checkbox
                                    name={"bis-onboarding-privacy3"}
                                    value={"bis-onboarding-privacy3"}
                                    label={""}
                                    onChange={(val) =>
                                        setBodyRequest({
                                            ...bodyRequest,
                                            acceptMarketing: val,
                                        })
                                    }
                                    checked={bodyRequest.acceptMarketing}
                                />
                                <FormattedMessage id="onboarding.privacy3" />
                            </div>
                            <div className="bis-onboarding-settings-content-form-section-privacy-line">
                                <Checkbox
                                    name={"bis-onboarding-privacy4"}
                                    value={"bis-onboarding-privacy4"}
                                    label={""}
                                    onChange={(val) =>
                                        setBodyRequest({
                                            ...bodyRequest,
                                            acceptShareData: val,
                                        })
                                    }
                                    checked={bodyRequest.acceptShareData}
                                />
                                <FormattedMessage id="onboarding.privacy4" />
                            </div>
                        </div>
                    </div>
                    <div className="bis-onboarding-settings-content-footer">
                        <Button
                            onClick={() => props.setStep(1)}
                            kind="tertiary"
                        >
                            <FormattedMessage id="actions.cancel" />
                        </Button>
                        <Button
                            onClick={() =>
                                props.onSave({
                                    ...bodyRequest,
                                    expiringDate: moment(
                                        bodyRequest.expiringDate,
                                    ).format("YYYYMMDD"),
                                })
                            }
                            disabled={!enableSave}
                        >
                            <FormattedMessage id="actions.confirm" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingStep2;
